var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container mw-100 ob1-card px-1 me-1",
      class:
        _vm.dto.detainedVariation || _vm.dto.notEligibleVariation
          ? ""
          : "ob1-card-multiple",
    },
    [
      _c("div", { staticClass: "col-12 px-0" }, [
        _c("div", { staticClass: "row" }, [
          _vm.dto.detainedVariation
            ? _c("div", { staticClass: "col-12" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 px-1" }, [
            _c(
              "div",
              { staticClass: "row align-items-center internet-banner" },
              [
                _vm.dto.tag
                  ? _c("div", { staticClass: "col-auto p-0 pe-1" }, [
                      _c("div", { staticClass: "ob1-tag ob1-tag-primary" }, [
                        _c("span", {
                          domProps: { textContent: _vm._s(_vm.dto.tag) },
                        }),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 py-1 px-2" }, [
            _c("div", { staticClass: "bloc-title" }, [
              _c("div", {
                staticClass: "h3 mb-0 pb-0",
                domProps: { textContent: _vm._s(_vm.dto.label) },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm.dto.price
            ? _c("div", { staticClass: "col-12 px-2 pt-1" }, [
                _c(
                  "div",
                  { staticClass: "bloc-price" },
                  [
                    _c("ob1-prix", {
                      staticClass: "price-align",
                      attrs: {
                        custom: _vm.priceCustomClasses,
                        duration: _vm.dto.price.duration,
                        "initial-price": _vm.dto.price.initialPrice,
                        "is-compact": _vm.dto.price.compact,
                        price: _vm.dto.price.price,
                        "price-label": _vm.dto.price.priceLabel,
                        "price-details": _vm.dto.price.priceDetails,
                        "show-by-month": _vm.dto.price.showByMonth,
                        "show-end-of-promotion-price":
                          _vm.dto.price.showEndOfPromotionPrice,
                        "show-from": _vm.dto.price.showFrom,
                        "show-promo-duration": _vm.dto.price.showPromoDuration,
                        "additional-mention-normal":
                          _vm.dto.price.additionalMention,
                      },
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "bloc-price-mentions" }, [
                        _vm.dto.legalNotice
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "safe-html",
                                    rawName: "v-safe-html",
                                    value: _vm.dto.legalNotice,
                                    expression: "dto.legalNotice",
                                  },
                                ],
                                staticClass:
                                  "ob1-price ob1-price-compact ob1-price-promo-duration",
                              },
                              [_vm._v("Mention légale")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dto.legalNotice && _vm.dto.commitment
                          ? _c("br")
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dto.commitment
                          ? _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "safe-html",
                                    rawName: "v-safe-html",
                                    value: _vm.dto.commitment,
                                    expression: "dto.commitment",
                                  },
                                ],
                                staticClass:
                                  "ob1-price-promo-duration text-black fw-bold",
                              },
                              [_vm._v("Engagement X mois")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dto.commitment && _vm.dto.terminationDetailLink
                          ? _c("br")
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.dto.commitment &&
                        _vm.dto.legalNotice &&
                        _vm.dto.terminationDetailLink
                          ? _c("br")
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dto.terminationDetailLink
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "safe-html",
                                      rawName: "v-safe-html",
                                      value:
                                        _vm.dto.terminationDetailLink.linkLabel,
                                      expression:
                                        "dto.terminationDetailLink.linkLabel",
                                    },
                                  ],
                                  staticClass: "ob1-link",
                                  attrs: {
                                    "data-bs-toggle": "modal",
                                    href: "#",
                                    "data-bs-target":
                                      "#modal-termination-" +
                                      _vm.dto.terminationDetailLink.popinName,
                                    "data-oevent-category":
                                      _vm.dto.terminationDetailLink.tmsData
                                        .category,
                                    "data-oevent-action":
                                      _vm.dto.terminationDetailLink.tmsData
                                        .action,
                                    "data-oevent-label":
                                      _vm.dto.terminationDetailLink.tmsData
                                        .label,
                                  },
                                },
                                [_vm._v("Résiliable à tout moment")]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dto.detainedVariation
            ? _c(
                "div",
                {
                  staticClass: "col-12 px-2 py-1 d-flex justify-content-center",
                },
                [
                  _c("div", { staticClass: "bloc-button w-100" }, [
                    _c(
                      "p",
                      {
                        staticClass: "alert alert-info",
                        attrs: { role: "alert" },
                      },
                      [
                        _c("span", {
                          staticClass: "alert-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "ob1-alert-title",
                          attrs: {
                            "data-variation-info":
                              _vm.dto.cta.label + " " + _vm.dto.label,
                          },
                          domProps: { textContent: _vm._s(_vm.dto.cta.label) },
                        }),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.dto.detainedVariation
            ? _c(
                "div",
                {
                  staticClass: "col-12 px-2 py-1 d-flex justify-content-center",
                },
                [
                  _c("div", { staticClass: "bloc-button w-100" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary w-100",
                        class:
                          _vm.dto.notEligibleVariation ||
                          _vm.dto.isAuthenticatedWithoutAnyContract
                            ? "disabled"
                            : "",
                        attrs: {
                          href: _vm.dto.cta.actionUrl,
                          "data-variation-cta":
                            _vm.dto.cta.label + " " + _vm.dto.label,
                          "data-oevent-category": _vm.dto.cta.tmsData.category,
                          "data-oevent-action": _vm.dto.cta.tmsData.action,
                          "data-oevent-label": _vm.dto.cta.tmsData.label,
                          "aria-disabled":
                            _vm.dto.notEligibleVariation ||
                            _vm.dto.isAuthenticatedWithoutAnyContract,
                        },
                      },
                      [_vm._v(_vm._s(_vm.dto.cta.label))]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dto.contractsLinkLabel
            ? _c("div", { staticClass: "col-12 px-2 pb-1" }, [
                _c(
                  "a",
                  {
                    staticClass: "ob1-link",
                    attrs: { href: _vm.dto.contractsLinkUrl },
                  },
                  [_vm._v(_vm._s(_vm.dto.contractsLinkLabel))]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dto.attributes
            ? _c("div", { staticClass: "col-12 px-2 text-center" }, [
                _c("hr", { staticClass: "separator separator--gray4" }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dto.attributes
            ? _c("div", { staticClass: "col-12 pt-1 pb-2" }, [
                _c(
                  "ul",
                  { staticClass: "bloc-attributs list-unstyled px-1 mb-0" },
                  _vm._l(_vm.dto.attributes, function (attribute) {
                    return _c("li", { staticClass: "attribute" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-baseline" },
                        [
                          attribute.icon
                            ? _c("span", {
                                staticClass: "icon",
                                class: attribute.icon,
                                attrs: { "aria-hidden": "true" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "safe-html",
                                  rawName: "v-safe-html",
                                  value: attribute.description,
                                  expression: "attribute.description",
                                },
                              ],
                              staticClass: "attribute-label ps-1",
                            },
                            [_vm._v("2 écrans")]
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "corner-banner" }, [
      _c("span", {
        staticClass: "icon icon-tick text-white corner-banner-icon float-end",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 px-2 text-center separator-before-price" },
      [_c("hr", { staticClass: "separator separator--gray4" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }